<div class="row">
  <div
    class="bn-item-list-selection z-0"
    [ngClass]="{ 'bn-item-list-selection--list-only': !hasRightPanelContent }">
    <bn-web-ui-card
      class="bn-item-list-selection__left z-1 border-top-left-radius-lg border-bottom-left-radius-lg"
      [borderRadiuses]="hasRightPanelContent ? ['lg', 'none', 'none', 'lg'] : ['lg', 'lg', 'lg', 'lg']"
      [heading]="heading"
      [isFullHeight]="true"
      [isLoading]="isLoading">
      @let headerLink = link();
      @if (headerLink) {
        <div class="bn-item-list-selection__left__link">
          <a [routerLink]="headerLink.routerLink">
            {{ headerLink.text }}
            <fa-icon icon="arrow-right" />
          </a>
        </div>
      }
      <div class="bn-item-list-selection__left__items mt-4">
        @for (item of list; track item; let itemIndex = $index) {
          @let isSelected = itemIndex === selectedItemIndex;
          @if (!item.hide) {
            <div
              class="bn-item-list-selection__left__items__item {{ item.extraClass }}"
              [ngClass]="{
                'bn-item-list-selection__left__items__item--selected': isSelected,
                'bn-item-list-selection__left__items__item--has-bg': item.hasBg,
                'bn-item-list-selection__left__items__item--no-hover': item.noHover,
                'bn-item-list-selection__left__items__item--no-border': item.noBorder,
                'bn-item-list-selection__left__items__item--not-selectable': item.notSelectable,
              }"
              (click)="handleItemClick(itemIndex)">
              @if (isDoubleSection(item)) {
                @for (name of item.names; track name; let itemIndex = $index) {
                  <div class="d-flex justify-content-between">
                    @let description = item.descriptions[itemIndex];
                    <span class="bn-item-list-selection__left__items__item__name">{{ name }}</span>
                    <span
                      class="bn-item-list-selection__left__items__item__description"
                      [ngClass]="{ 'text-300-bold': item.descriptionIsBold }"
                      >{{ description }}</span
                    >
                  </div>
                }
              } @else {
                @if (isSectionBase(item)) {
                  <div class="d-flex justify-content-between">
                    <span class="bn-item-list-selection__left__items__item__name">
                      @if (!item.notSelectable) {
                        <fa-icon
                          icon="chart-pie-simple-circle-dollar"
                          [ngClass]="{
                            'text-dark-6': !isSelected,
                            'text-dark-8': isSelected,
                          }" />
                      }
                      {{ item.name }}
                    </span>
                    <span
                      class="bn-item-list-selection__left__items__item__description"
                      [ngClass]="{ 'text-300-bold': item.descriptionIsBold }">
                      {{ item.description }}
                    </span>
                  </div>
                }
              }
              @if (isSelected && hasRightPanelContent) {
                <img
                  class="bn-item-list-selection__left__items__item__arrow bn-item-list-selection__left__items__item__arrow--light"
                  src="/assets/libs/web-ui/images/right-arrow-light.svg" />
                <img
                  class="bn-item-list-selection__left__items__item__arrow bn-item-list-selection__left__items__item__arrow--dark"
                  src="/assets/libs/web-ui/images/right-arrow-dark.svg" />
              }
            </div>
          }
        }
      </div>
    </bn-web-ui-card>
    @if (hasRightPanelContent) {
      <bn-web-ui-card
        class="bn-item-list-selection__right"
        [borderRadiuses]="['none', 'lg', 'lg', 'none']"
        [isFullHeight]="true"
        [isLoading]="isLoading">
        <div class="d-flex flex-column justify-content-between h-100">
          <span class="bn-item-list-selection__right__items">
            @if (list?.[selectedItemIndex]; as selectedItemItems) {
              @if (isSectionBase(selectedItemItems)) {
                @if (selectedItemItems.items) {
                  @for (subItem of selectedItemItems.items | visibleItems; track subItem; let i = $index) {
                    @if (!subItem.hide) {
                      <div
                        class="bn-item-list-selection__right__items__item d-flex justify-content-between"
                        [ngClass]="{
                          'bn-item-list-selection__right__items__item--selected': selectedSubItemIndex() === i,
                        }"
                        (mouseenter)="hoverSliceByName(subItem.name)"
                        (mouseleave)="clearHover()">
                        <div class="position-relative">
                          <span class="bn-item-list-selection__right__items__item__indicator {{ subItem.indicator }}"></span>
                          <div class="d-inline-block ms-3">
                            <div class="bn-item-list-selection__right__items__item__name">{{ subItem.name }}</div>
                            <div class="bn-item-list-selection__right__items__item__description__bottom">{{ subItem.description.bottom }}</div>
                          </div>
                        </div>
                        <div
                          class="bn-item-list-selection__right__items__item__description"
                          containerClass="m-1"
                          [tooltip]="subItem.description.right?.tooltip ?? undefined">
                          {{ subItem.description.right?.text ?? '' }}
                        </div>
                      </div>
                    }
                  }
                }
              }
            }
          </span>
          <bn-web-ui-chart
            #chartComponent
            class="opacity-0"
            theme="bn-chart-theme"
            [chartType]="chartTypes.Pie"
            [ngClass]="{ 'opacity-100': (seriesArray[0].data.length || 0) > 0 }"
            [options]="chartOptions"
            (chartReady)="onChartReady($event)" />
        </div>
      </bn-web-ui-card>
    }
  </div>
</div>
